// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type EventMap = Record<string, any>;
export type EventKey<T extends EventMap> = string & keyof T;
type EventReceiver<T> = (params: T) => void;
type EventListeners<T extends EventMap> = {
    [K in EventKey<T>]: Array<EventReceiver<T[K]>>;
};

export default class EventEmitter<T extends EventMap> {
    private listeners = {} as EventListeners<T>;

    on<K extends EventKey<T>>(eventName: K, fn: EventReceiver<T[K]>) {
        this.listeners[eventName] = this.listeners[eventName] || [];
        this.listeners[eventName].push(fn);

        return this;
    }

    off<K extends EventKey<T>>(eventName: K, fn?: EventReceiver<T[K]>) {
        if (fn) {
            this.listeners[eventName] = (this.listeners[eventName] || []).filter((_fn) => fn !== _fn);
        } else {
            delete this.listeners[eventName];
        }

        return this;
    }

    emit<K extends EventKey<T>>(eventName: K, params: T[K]) {
        (this.listeners[eventName] || []).forEach((listener) => {
            listener.call(this, params);
        });

        return this;
    }
}
